import { Button } from '@mui/material';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import Grid from 'components/core/Grid';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SearchIcon from '@mui/icons-material/Search';
import { useRouter } from 'next/router';
import { httpsUrl } from 'config/url';
import { CheckoutStepProps } from 'pages/[propertyId]/reservenow';

export const CheckoutPickNewDatesBackToSearch = ({
  startDate,
  endDate,
  checkoutData,
}: Pick<CheckoutStepProps, 'startDate' | 'endDate' | 'checkoutData'>) => {
  const router = useRouter();

  const onClickAdjustDates = () => {
    const nextQuery: Record<string, any> = { ...router.query, step: 1 };
    delete nextQuery.startDate;
    delete nextQuery.endDate;

    router.push({
      pathname: router.pathname,
      query: nextQuery,
    });
  };

  const onClickBackToSearch = () => {
    const resortId = checkoutData?.BOOKING?.PROPERTY.ADDRESS.RESORT_ID;
    window.location.href = `${httpsUrl()}/search/?resortID=${resortId}&perPage=12&resultsPage=1&sortBy=priceUp&arrival=${startDate}&departure=${endDate}`;
  };

  return (
    <Grid item xs={12} sx={{ mt: 2 }}>
      <AppDivider />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CheckoutSectionTitle>Adjust Dates</CheckoutSectionTitle>
          <Button variant="outlined" fullWidth startIcon={<CalendarMonthIcon />} onClick={onClickAdjustDates}>
            Pick New Dates
          </Button>
        </Grid>
        <Grid item xs={12}>
          <CheckoutSectionTitle>Or Try Searching For a Different Property</CheckoutSectionTitle>
          <Button variant="outlined" fullWidth startIcon={<SearchIcon />} onClick={onClickBackToSearch}>
            Back to Search
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
